import { AppError } from '.';
import { AppErrorCode } from './error-codes';

/**
 * Common errors used in error handling.
 * @example throw new AppError(commonErrors.CMSDataLoad.name, 'Failed to fetch CMS data', res.status);
 */
export const commonErrors = {
	Unauthorized: { name: 'Unauthorized', message: 'Unauthorized access', code: '', HTTPStatus: 401 },
	CMSDataFetchNotOK: {
		name: 'CMSDataFetchNotOKError',
		message: 'CMS data failed to load (response not OK).',
		code: AppErrorCode.APP_CMS_DATA_FETCH_NOT_OK_ERROR
	},
	CMSDataFetch: { name: 'CMSDataFetchError', message: 'CMS data failed to load.', code: AppErrorCode.APP_CMS_DATA_FETCH_ERROR },
	CMSDataValidation: {
		name: 'CMSDataValidationError',
		message: 'CMS data validation error.',
		code: AppErrorCode.APP_CMS_DATA_VALIDATION_ERROR
	},
	CMSTranslationsFetchNotOK: {
		name: 'CMSTranslationsFetchNotOKError',
		message: 'CMS translations failed to load (response not OK).',
		code: AppErrorCode.APP_CMS_TRANSLATIONS_FETCH_NOT_OK_ERROR
	},
	CMSTranslationsFetch: {
		name: 'CMSTranslationsFetchError',
		message: 'CMS translations failed to load.',
		code: AppErrorCode.APP_CMS_TRANSLATIONS_FETCH_ERROR
	},
	EnvInvalid: { name: 'env-invalid-error', message: 'Environment variables are invalid.', code: AppErrorCode.APP_ENV_INVALID_ERROR },
	EnvServerAccess: {
		name: 'env-server-access-error',
		message: 'Tried accessing server environment variable on the client',
		code: AppErrorCode.APP_ENV_SERVER_ACCESS_ERROR
	},
	UnknownError: { name: 'UnknownError', message: 'Unknown error', code: AppErrorCode.APP_UNKNOWN_ERROR, HTTPStatus: 500 }
};

// /**
//  * Defines common errors and provides factory functions to create instances of those errors.
//  * @example throw commonErrors.UnauthorizedError('Unauthorized access');
//  * TODO: Define better use cases for these. The idea behind them is to be able to throw the same error multiple times
//  * avoiding the duplication of passing the same parameters again and again, like httpStatus, code, etc.
//  */
export const errors = {
	UnauthorizedError: (message: string, name = null) =>
		new AppError({
			name: name || commonErrors.Unauthorized?.name || '',
			message: message || commonErrors.Unauthorized?.name || '',
			code: '',
			HTTPStatus: commonErrors.Unauthorized?.HTTPStatus
		}),
	UnknownError: (message: string, name = null) =>
		new AppError({
			name: name || commonErrors.UnknownError?.name || '',
			message,
			code: commonErrors.UnknownError?.code || AppErrorCode.APP_UNKNOWN_ERROR,
			HTTPStatus: commonErrors.UnknownError?.HTTPStatus
		})
};
export function errorIsInstanceOf(error: Error, code: AppErrorCode): boolean {
	return 'code' in error && error.code === code;
}
